export const SinglePageActions = {
    FETCH_SINGLE_PAGE: 'FETCH_SINGLE_PAGE',
    FETCH_SINGLE_PAGE_RETURN: 'FETCH_SINGLE_PAGE_RETURN',

    SAVE_PAGE_CONTENTS: 'SAVE_PAGE_CONTENTS',
    SAVE_PAGE_CONTENTS_DONE: 'SAVE_PAGE_CONTENTS_DONE',
    CLEAR_SAVE_PAGE_CONTENTS: 'CLEAR_SAVE_PAGE_CONTENTS',

    UPDATE_PAGE_SETTINGS: 'UPDATE_PAGE_SETTINGS',
    UPDATING_PAGE_SETTINGS: 'UPDATING_PAGE_SETTINGS',
    UPDATE_PAGE_SETTINGS_SUCCESS: 'UPDATE_PAGE_SETTINGS_SUCCESS',
    UPDATE_PAGE_SETTINGS_FAILED: 'UPDATE_PAGE_SETTINGS_FAILED',
    CLEAR_UPDATE_PAGE_SETTINGS: 'CLEAR_UPDATE_PAGE_SETTINGS',

    CLEAR_SINGLE_PAGE: 'CLEAR_SINGLE_PAGE',

    ADD_COMPONENT_TO_PAGE: 'ADD_COMPONENT_TO_PAGE',
    UPDATE_COMPONENT_OF_PAGE: 'UPDATE_COMPONENT_OF_PAGE',
    CLEAR_COMPONENTS_OF_FIELD: 'CLEAR_COMPONENTS_OF_FIELD',
    REMOVE_SINGLE_COMPONENT_OF_FIELD: 'REMOVE_SINGLE_COMPONENT_OF_FIELD',
    SWAP_COMPONENTS_OF_FIELD: 'SWAP_COMPONENTS_OF_FIELD'
};

export const fetchSinglePage = payload => ({
    type: SinglePageActions.FETCH_SINGLE_PAGE,
    payload
});

export const fetchSinglePageReturn = payload => ({
    type: SinglePageActions.FETCH_SINGLE_PAGE_RETURN,
    payload
});

export const savePageContents = payload => ({
    type: SinglePageActions.SAVE_PAGE_CONTENTS,
    payload
});
export const savePageContentsDone = payload => ({
    type: SinglePageActions.SAVE_PAGE_CONTENTS_DONE,
    payload
});
export const clearSavePageContents = () => ({
    type: SinglePageActions.CLEAR_SAVE_PAGE_CONTENTS
});

export const updatePageSettings = (payload, resolve, reject) => ({
    type: SinglePageActions.UPDATE_PAGE_SETTINGS,
    payload
});
export const updatingPageSettings = () => ({
    type: SinglePageActions.UPDATING_PAGE_SETTINGS
});
export const updatePageSettingsSuccess = payload => ({
    type: SinglePageActions.UPDATE_PAGE_SETTINGS_SUCCESS,
    payload
});
export const updatePageSettingsFailed = payload => ({
    type: SinglePageActions.UPDATE_PAGE_SETTINGS_FAILED,
    payload
});
export const clearUpdatePageSettings = payload => ({
    type: SinglePageActions.CLEAR_UPDATE_PAGE_SETTINGS,
    payload
});

export const clearSinglePage = () => ({
    type: SinglePageActions.CLEAR_SINGLE_PAGE
});

export const addComponentToPage = payload => ({
    type: SinglePageActions.ADD_COMPONENT_TO_PAGE,
    payload
});

export const updateComponentOfPage = payload => ({
    type: SinglePageActions.UPDATE_COMPONENT_OF_PAGE,
    payload
});

export const clearComponentsOfField = payload => ({
    type: SinglePageActions.CLEAR_COMPONENTS_OF_FIELD,
    payload
});

export const removeSingleComponentOfField = payload => ({
    type: SinglePageActions.REMOVE_SINGLE_COMPONENT_OF_FIELD,
    payload
});

export const swapComponentsOfField = payload => ({
    type: SinglePageActions.SWAP_COMPONENTS_OF_FIELD,
    payload
});
